type languages_type = {
  JAPANESE: string;
  ENGLISH: string;
  CHINESE: string;
};

export const LANGUAGES: languages_type = {
  JAPANESE: 'jp',
  ENGLISH: 'en',
  CHINESE: 'zh',
};

export const SELECTED_LANGUAGE = localStorage.getItem("lang");